<ifr-page-title pageTitle="'LEFT_PANEL_START_PAGE' | translate "/>

<react-dashboard 
navigate-to="navigateTo"  
will-leave="vm.willLeave"
on-will-leave-result="onWillLeaveResult" 
lic-key="licKey"
/>
